export default __webpack_public_path__ + "static/moritz-8f51734492cae95d059273920d141d66.jpeg";